import React from "react";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";
import { TiktokIcon } from "./icons";
import { CONTACT, LOGO_URL, NAV_LINKS, waLink } from "../data/content";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-navy text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="FYLegal.ID" className="h-12 w-12 rounded-full object-cover ring-1 ring-white/20" />
              <div>
                <p className="font-serif text-xl font-semibold">
                  FY<span className="text-gold">Legal.ID</span>
                </p>
                <p className="text-[11px] uppercase tracking-[0.2em] text-white/50">For Your Legal Needs</p>
              </div>
            </div>
            <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-sm">
              Layanan hukum profesional di bawah naungan {CONTACT.company}. Mendampingi individu, UMKM,
              startup, hingga perusahaan dengan solusi hukum yang praktis dan terpercaya.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm uppercase tracking-[0.2em] text-gold mb-5">Navigasi</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/70 hover:text-gold transition-colors text-sm">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-sm uppercase tracking-[0.2em] text-gold mb-5">Hubungi Kami</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-white/70 hover:text-gold transition-colors">
                  <Phone className="h-4 w-4 mt-0.5 text-gold shrink-0" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-start gap-3 text-white/70 hover:text-gold transition-colors">
                  <Mail className="h-4 w-4 mt-0.5 text-gold shrink-0" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="h-4 w-4 mt-0.5 text-gold shrink-0" /> {CONTACT.address}
              </li>
              <li>
                <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-white/70 hover:text-gold transition-colors">
                  <Instagram className="h-4 w-4 mt-0.5 text-gold shrink-0" /> {CONTACT.instagramHandle}
                </a>
              </li>
              <li>
                <a href={CONTACT.tiktok} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-white/70 hover:text-gold transition-colors">
                  <TiktokIcon className="h-4 w-4 mt-0.5 text-gold shrink-0" /> {CONTACT.tiktokHandle}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/50">© 2026 {CONTACT.company}. Seluruh hak cipta dilindungi.</p>
          <p className="text-xs text-white/40">Profesional • Transparan • Solutif • Responsif • Terintegrasi</p>
        </div>
      </div>
    </footer>
  );
};
